import { render, staticRenderFns } from "./BrainstormClustering.vue?vue&type=template&id=19e5b329&scoped=true&"
import script from "./BrainstormClustering.vue?vue&type=script&lang=js&"
export * from "./BrainstormClustering.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormClustering.vue?vue&type=style&index=0&id=19e5b329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5b329",
  null
  
)

export default component.exports